var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25033 8.16667H3.83366C3.36695 8.16667 3.13359 8.16667 2.95533 8.25749C2.79853 8.33739 2.67105 8.46487 2.59115 8.62167C2.50033 8.79993 2.50033 9.03329 2.50033 9.5V16.5M13.7503 8.16667H16.167C16.6337 8.16667 16.8671 8.16667 17.0453 8.25749C17.2021 8.33739 17.3296 8.46487 17.4095 8.62167C17.5003 8.79993 17.5003 9.03329 17.5003 9.5V16.5M13.7503 16.5V4.16667C13.7503 3.23325 13.7503 2.76654 13.5687 2.41002C13.4089 2.09641 13.1539 1.84144 12.8403 1.68166C12.4838 1.5 12.0171 1.5 11.0837 1.5H8.91699C7.98357 1.5 7.51686 1.5 7.16034 1.68166C6.84674 1.84144 6.59177 2.09641 6.43198 2.41002C6.25033 2.76654 6.25033 3.23325 6.25033 4.16667V16.5M18.3337 16.5H1.66699M9.16699 4.83333H10.8337M9.16699 8.16667H10.8337M9.16699 11.5H10.8337",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.d3a198608f8d3a83934e6a3b827dfd53.svg";
export { ForwardRef as ReactComponent };